// Imports
import ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ from "../../../node_modules/html-loader/dist/runtime/getUrl.js";
var ___HTML_LOADER_IMPORT_0___ = new URL("./setup-signage-logo.svg", import.meta.url);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<div class=\"setup-panel__item setup-panel__item--position-left\">\n  <img class=\"setup-logo\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\" />\n</div>\n";
// Exports
export default code;